define(function(require) {
    var DomUtil = require("cartovista").DomUtil;
    return {
        ID: "Res_MRC_1",
        THEMESETS_IDS: ["Res_MRC_1"],
        SOURCE: '<span style="margin-top:15px; float:right; font-size:10px;">Source : MEQ, SIP, DGPP, DGVI, DIS, Taux de diplomation et qualification par cohorte au secondaire - édition 2026.</span>',
        BOTTOM_PANEL: {
            PRINT_OPTIONS: {"landscape": true, "scale": 0.5},
            DEFAULTS: {
                ACTIVE_LAYER_ID: "GEO09E05_MRC_GEN",
                GRAPH_TYPE: "line",
                GRAPH_DATA_ORIENTATION: "rows",
                PADDING: {"left": 30, "top": 0, "right": 15, "bottom": 30},
                HEIGHT_FN: function() {
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-bottom-pane").height() - 80;
                    else return 315;
                },
                WIDTH_FN: function() {
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-bottom-pane").width() - 40;
                    else return $("#cv-responsiveBbGraphsBottom").width() - 10;
                },
                X_DATA_NAMES: ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
                X_AXIS_LABEL: {"text": "Cohortes", "position": "outer-right"},
                Y_AXIS_LABEL: "%",
                TOOLTIP_TITLE_FN: function(x, graph) { return "Cohorte de " + graph.categories()[x] + "-" + (parseInt(graph.categories()[x])+1); }
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + "%";}
            },
            TABS: [
                {
                    BUTTON_TITLE: "Sexes réunis",
                    GRAPHS: [
                        {
                            TITLE: "Évolution des taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexes réunis, cohortes de 1998 à 2017",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E05_MRC_GEN",
                                    DATATABLE_ID: "t_GEO09E05_MRC_GEN_residence",
                                    DATACOLUMNS_IDS: ["TX_5_T_1998", "TX_5_T_1999", "TX_5_T_2000", "TX_5_T_2001", "TX_5_T_2002", "TX_5_T_2003", "TX_5_T_2004", "TX_5_T_2005", "TX_5_T_2006", "TX_5_T_2007", "TX_5_T_2008", "TX_5_T_2009", "TX_5_T_2010", "TX_5_T_2011", "TX_5_T_2012", "TX_5_T_2013", "TX_5_T_2014", "TX_5_T_2015", "TX_5_T_2016", "TX_5_T_2017"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                            ]
                        }
                    ]
                }, {
                    BUTTON_TITLE: "Sexe masculin",
                    GRAPHS: [
                        {
                           TITLE: "Évolution des taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe masculin, cohortes de 1998 à 2017",
                           DATA_SOURCES: [
                               {
                                   LAYER_ID: "GEO09E05_MRC_GEN",
                                   DATATABLE_ID: "t_GEO09E05_MRC_GEN_residence",
                                   DATACOLUMNS_IDS: ["TX_5_M_1998", "TX_5_M_1999", "TX_5_M_2000", "TX_5_M_2001", "TX_5_M_2002", "TX_5_M_2003", "TX_5_M_2004", "TX_5_M_2005", "TX_5_M_2006", "TX_5_M_2007", "TX_5_M_2008", "TX_5_M_2009", "TX_5_M_2010", "TX_5_M_2011", "TX_5_M_2012", "TX_5_M_2013", "TX_5_M_2014", "TX_5_M_2015", "TX_5_M_2016", "TX_5_M_2017"],
                                   NO_SELECTION_SHOW_ALL_FEATURES: false
                               }
                           ]
                       }
                    ]
                }, {
                    BUTTON_TITLE: "Sexe féminin",
                    GRAPHS: [
                        {
                            TITLE: "Évolution des taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe féminin, cohortes de 1998 à 2017",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E05_MRC_GEN",
                                    DATATABLE_ID: "t_GEO09E05_MRC_GEN_residence",
                                    DATACOLUMNS_IDS: ["TX_5_F_1998", "TX_5_F_1999", "TX_5_F_2000", "TX_5_F_2001", "TX_5_F_2002", "TX_5_F_2003", "TX_5_F_2004", "TX_5_F_2005", "TX_5_F_2006", "TX_5_F_2007", "TX_5_F_2008", "TX_5_F_2009", "TX_5_F_2010", "TX_5_F_2011", "TX_5_F_2012", "TX_5_F_2013", "TX_5_F_2014", "TX_5_F_2015", "TX_5_F_2016", "TX_5_F_2017"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };
});
